// @Note Import Sugar locales
import 'sugar/locales/es';
import 'sugar/locales/fr';
import 'sugar/locales/nl';
import 'sugar/locales/de';

import { en } from './locales/en';
import { es } from './locales/es';
import { fr } from './locales/fr';
import { nl } from './locales/nl';

/**
 * I18n Calendar definitions for daterange and pickaday
 */
const i18n = {
  en,
  fr,
  es,
  nl,
  // @Note missing DE (German) language
};

/**
 * Current locale
 * @type {String}
 */
let locale = 'en';

/**
 * Provide translation strings for the calendars
 */
export class CalendarLocale {
  /**
   * Set locale
   * @param {String} newLocale
   */
  static set locale(newLocale) {
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    if (!i18n[newLocale]) return;

    locale = newLocale;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'setLocale' does not exist on type 'DateC... Remove this comment to see the full error message
    Date.setLocale(locale);

    if (window.merchantos.dateRange.domObject) {
      window.merchantos.dateRange.setup();
      window.merchantos.dateRange.domObject.hide();
    }

    window.merchantos.dateRange.i18n = CalendarLocale.getDaterangeTranslations(
      // @ts-expect-error ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
      CalendarLocale.locale
    );
    window.merchantos.dateRange.setRegexp();

    window.merchantos.datepicker.updatePikadayInputs();
  }

  /**
   * Get locale
   * @returns {String}
   */
  static get locale() {
    return locale;
  }

  /**
   * Get the daterange translation for locale
   * @returns {Object}
   */
  static getDaterangeTranslations() {
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    return i18n[locale].daterange;
  }

  /**
   * Get the pikaday translation for locale
   * @returns {Object}
   */
  static getPikadayTranslations() {
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    return i18n[locale].pikaday;
  }

  /**
   * Translate i18n strings replacing {1/2} by dates
   * @param {String} string
   */
  static translate(...args: TSFixMe[]) {
    const [string] = args;
    return string.replace(/\{(\d+)}/g, (_match: TSFixMe, index: TSFixMe) => {
      return args[index];
    });
  }
}

window.CalendarLocale = CalendarLocale;
